// check out the Flowbite Tabs JS behaviour docs for more information: https://flowbite.com/docs/components/tabs/#javascript-behaviour

// create an array of objects with the id, trigger element (eg. button), and the content element

// const tabElements = [
// 	{
// 		id: "testimonial-1",
// 		triggerEl: document.querySelector("#testimonial-1-tab"),
// 		targetEl: document.querySelector("#testimonial-1"),
// 	},
// 	{
// 		id: "testimonial-2",
// 		triggerEl: document.querySelector("#testimonial-2-tab"),
// 		targetEl: document.querySelector("#testimonial-2"),
// 	},
// 	{
// 		id: "testimonial-3",
// 		triggerEl: document.querySelector("#testimonial-3-tab"),
// 		targetEl: document.querySelector("#testimonial-3"),
// 	},
// ];

// // options with default values
// const options = {
// 	defaultTabId: "settings",
// 	activeClasses: "bg-gray-100 dark:bg-gray-700",
// 	inactiveClasses: "bg-white dark:bg-gray-900",
// 	onShow: () => {
// 		console.log("tab is shown");
// 	},
// };

// const tabs = new Tabs(tabElements, options);

document.addEventListener("DOMContentLoaded", function () {
	const thumbnailSlider = new Splide("#thumbnail-slider", {
		gap: "1rem",
		rewind: true,
		pagination: false,
		arrows: false,
		isNavigation: true,
		cover: true,
		perPage: 4,
        focus:false,
        breakpoints: {
            640: {
                direction:'ltr',
                perPage: 2,
                perMove:1,
            },
        }
	});

    const mainSlider = new Splide("#main-slider", {
        lazyLoad: "nearby",
        pagination: false,
        type: "loop",
        perPage: 1,
        perMove: 1,
        drag: true,
        keyboard: false,
    });

    mainSlider.sync( thumbnailSlider );
    mainSlider.mount();
    thumbnailSlider.mount();
});


/**
 * Affiche les liaisons d'un genre
 */
const loadGenreLiaison = async () => {
    Notiflix.Loading.dots();
    if (document.getElementById('selectGenre').value == '') {
        document.getElementById('contentLiaisonGenre').innerHTML = '';
        showPrice();
        return;
    }

    const resp = await fetch(Routing.generate('produit_liaison',{
        id: document.getElementById('productId').value,
        liaisonGenreId: document.getElementById('selectGenre').value,
    }));

    const html = await resp.text();
    document.getElementById('contentLiaisonGenre').innerHTML = html;

    showPrice();
    loadGenreLiaisonEvent();
};

/**
 * Init les events sur liaisons d'un genre
 */
const loadGenreLiaisonEvent = async () => {

    /**
     * Selection type de marquage
     */
    document.querySelector('#formAddToBasket select[name="type_marquage"]').addEventListener('change', () => {
        showPrice();
    });

    /**
     * Selection Prénom pour personnalisation
     */
    document.querySelectorAll('#formAddToBasket input[name="with_prenom_personnalisation"]').forEach((elm) => {
        elm.addEventListener('change', () => {
            showPrice();
        });
    })
};

/**
 * Sélection du genre
 */
document.getElementById('selectGenre').addEventListener('change', (e) => {
    loadGenreLiaison().then(() => {
        Notiflix.Loading.remove();
    });
});

/**
 * Personalisation prenom
 */
document.querySelectorAll('.radio-personalisation').forEach((elm) => {
    elm.addEventListener('click', (e) => {
        const value = e.currentTarget.value;
        if (value == '1') {
            document.querySelector('.personalisation-field').style.display = '';
        } else {
            document.querySelector('.personalisation-field').style.display = 'none';
        }
    });
});

/**
 * Modal ajouter au panier
 */
const modalAddToCart = new Modal(document.getElementById('modalAddToCart'));
document.querySelectorAll('#modalAddToCart [data-hide-modal]').forEach((elm) => {
    elm.addEventListener('click', () => {
        modalAddToCart.hide();
    });
});

/**
 * Form ajout au panier
 */
document.getElementById('formAddToBasket').addEventListener('submit', async (e) => {
    e.preventDefault();
    e.stopPropagation();
    Notiflix.Loading.dots();
    const formData = new FormData(e.currentTarget);
    const response = await fetch(Routing.generate('shop_cart_add', {
        id: document.getElementById('productId').value,
    }), {
        method: 'POST',
        body: formData
    });

    try {
        const data = await response.json();
        if (response.status != 200 || !data.success) {
            if (data.message) {
                Notiflix.Notify.failure(data.message);
            }else{
                return false;
            }
            Notiflix.Loading.remove();
        }else{
            const resp = await fetch(Routing.generate('produit_cart', {
                id: data.id
            }), {
                method: 'GET'
            });
            const html = await resp.text();
            NotifPanier.load();
            Notiflix.Loading.remove();
        
            document.querySelector('#modalAddToCart .modal-content').innerHTML = html;
        
            modalAddToCart.show();
        }
    } catch (error) {
        Notiflix.Notify.failure('Une erreur est survenue');
        Notiflix.Loading.remove();
    }
});
/**
 * Affiche le bon prix en fonction des sélections
 */
const showPrice = () => {
    const formData = new FormData(document.getElementById('formAddToBasket'));
    let price = 0;
    const select = document.querySelector('#formAddToBasket select[name="type_marquage"]');
    if (select) {
        const option = select.options[select.selectedIndex];
        if (option) {
            if (option.dataset.prix != undefined && (formData.get('with_prenom_personnalisation') == '0' || !formData.get('with_prenom_personnalisation'))) {
                price = option.dataset.prix;
            } else if (option.dataset.prixprenom != undefined && formData.get('with_prenom_personnalisation') == '1') {
                price = option.dataset.prixprenom;
            } else {
                price = document.getElementById('articlePrice').dataset.prix;
            }
        }else{
            price = document.getElementById('articlePrice').dataset.prix;
        }
        
    } else {
        price = document.getElementById('articlePrice').dataset.prix;
    }

    document.getElementById('articlePrice').innerText = `${price}€`;
};

/**
 * Input spin
 */
$('.spinner-ctn')
.spinner({
    min: 1
})


/**
 * Modal afficher un guide de taille
 */
const modalShowGuide = new Modal(document.getElementById('modal-showGuide'));
const containerShowGuide = document.querySelector('#modal-showGuide #showGuide-img');
const linkShowGuide = document.querySelector('#modal-showGuide #showGuide-download');
document.querySelectorAll('#modal-showGuide [data-hide-modal]').forEach((elm) => {
    elm.addEventListener('click', () => {
        modalShowGuide.hide();
    });
});

const btnShowGuide = document.querySelectorAll('.btn-showGuide');
btnShowGuide.forEach((elm) => {
    elm.addEventListener('click', (e) => {
        console.log(elm);
        e.preventDefault();
        e.stopPropagation();
        // Notiflix.Loading.dots();
        
        containerShowGuide.src = '';
        linkShowGuide.href = '#';
        const srcGuide = elm.dataset.guide;
        if (!(srcGuide == undefined || srcGuide == '')) {
            const linkGuide = elm.dataset.guideDownload;
            // On change le type
            if (srcGuide.indexOf('.pdf') != -1) {
                containerShowGuide.type = 'application/pdf';
            }else if (srcGuide.indexOf('.png') != -1) {
                containerShowGuide.type = 'image/png';
            }else if (srcGuide.indexOf('.jpg') != -1) {
                containerShowGuide.type = 'image/jpg';
            }else if (srcGuide.indexOf('.jpeg') != -1) {
                containerShowGuide.type = 'image/jpeg';
            }else if (srcGuide.indexOf('.webp') != -1) {
                containerShowGuide.type = 'image/webp';
            }else(
                containerShowGuide.type = 'image/jpeg'
            )
            containerShowGuide.src = srcGuide;
            if (linkGuide != undefined && linkGuide != '') {
                linkShowGuide.href = linkGuide;
            }
            modalShowGuide.show();
        }
    });
});